<template>
  <MSelect
    item-value="iso"
    :selection-text-class="selectionTextClass"
    :selection-class="selectionClass"
    :label="label"
    :label-class="labelClass"
    :header-text="headerText"
    :items="countries"
    :placeholder="placeholder ?? $t('select_a_country')"
    filter
    :filter-placeholder="filterPlaceholder"
    :filter-by="['iso', 'labels.label', 'labels.keywords', 'dialCode']"
    :no-overlay="noOverlay"
    :no-arrow="noArrow"
    :outlined="outlined"
    :required-message="requiredMessage"
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    popover-class="h-full md:h-auto"
  >
    <template #selection="{ selectedItem }">
      <span class="flag rounded-4" :class="`flag-${selectedItem.iso.toLowerCase()}`" />
      <span class="truncate">
        {{ getSelectedItemLabel(selectedItem) }}
      </span>
    </template>

    <template #item="{ item }">
      <div class="flex items-center gap-1">
        <span class="flag rounded-4" :class="`flag-${item.iso.toLowerCase()}`" />
        <span v-if="displayMode === 'dialCode'" class="mr-5">{{ item.dialCode }}</span>
        {{ item.labels.label }}
      </div>
    </template>
  </MSelect>
</template>

<script lang="ts" setup>
import type { Country } from '@core/plugins/master-data/types'

defineEmits(['update:modelValue'])

const { $masterData } = useNuxtApp()

const props = withDefaults(
  defineProps<{
    modelValue?: string | null
    label?: string
    placeholder?: string
    filterPlaceholder?: string
    noOverlay?: boolean
    noArrow?: boolean
    displayMode?: 'dialCode' | 'default'
    selectionTextClass?: string
    selectionClass?: string
    headerText: string
    requiredMessage?: string
    labelClass?: string
    outlined?: boolean
  }>(),
  { modelValue: null, displayMode: 'default' },
)

const countries = computed(() => {
  return Array.from($masterData.countries.values())
})

const getSelectedItemLabel = (country: Country) => {
  if (props.displayMode === 'dialCode') {
    return country.dialCode
  } else {
    return country.labels.label
  }
}
</script>
